/**
 * Created by mzietek on 2016-11-19.
 */

(function(){

  angular
    .module('repairforms.directive.module')
    .directive('restrictSpecialCharacters', restrictSpecialCharacters);

  restrictSpecialCharacters.$inject = ['FormInputPossibleErrors'];

  function restrictSpecialCharacters (FormInputPossibleErrors) {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ctrl) {
        var errors = FormInputPossibleErrors.getPossibleErrors();

        var specialCharacter1 = /["%/\[\](){}<>:]/;
        var specialCharacter2 = /^((?!\w\.\w).)*$/;

        ctrl.$validators[errors.PATTERN] = checkIfSpecialCharacters;

        function checkIfSpecialCharacters(value) {
          if(attrs.required){
            if(value !== null && value !== ""){
              return (!specialCharacter1.test(value) && specialCharacter2.test(value));
            }else {
              return false;
            }
          }else {
            return (!specialCharacter1.test(value) && specialCharacter2.test(value));
          }
        };
      }
    };
  }

})();